module.exports = __webpack_public_path__ + "static/media/light-icon-messages.fc1590e8.png";